import React from 'react'
import { Grid, Icon } from 'semantic-ui-react';
import Labels from './../../../../common/Labels'
import MomentDateAndTime from '../../../../../helpers/momentDateAndTime';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import ModifiedOn from './ModifiedOn'

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Summary Card');
    }
})

class Summary extends React.Component {

    render() {

        const authorObj = this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length ?
            this.props.selectedPracticeLibrary.participants.filter((participant, index) => {
                return participant.role === 'author'
            }) : '';


        return (
            <div >
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Grid.Row>
                                <Labels
                                    name="Name"
                                    text={this.props.selectedPracticeLibrary.name} />
                            </Grid.Row>
                            <Grid.Row>
                                <Labels
                                    name="Current Status"
                                    text={this.props.selectedPracticeLibrary.status === 0 ? "In Design"
                                        : this.props.selectedPracticeLibrary.status === 1 ? "Review request"
                                            : this.props.selectedPracticeLibrary.status === 2 ? "Approved"
                                                : this.props.selectedPracticeLibrary.status === 3 ? "Rejected"
                                                    : this.props.selectedPracticeLibrary.status === 4 ? "Published"
                                                        : this.props.selectedPracticeLibrary.status === 5 ? "Inactive"
                                                            : this.props.selectedPracticeLibrary.status === 6 ? "Clone /Purchased"
                                                                : ''} />
                            </Grid.Row>
                            <Grid.Row>
                                <Labels
                                    name="Created On"
                                    text={MomentDateAndTime(this.props.selectedPracticeLibrary.createdAt)} />
                            </Grid.Row>
                            <Grid.Row>
                                <ModifiedOn />

                            </Grid.Row>
                            {/* version  */}
                            <Grid.Row>
                                <Labels
                                    name="Current Version"
                                    text={this.props.selectedPracticeLibrary ? this.props.selectedPracticeLibrary.version: null } />
                            </Grid.Row>
                            <Grid.Row>
                                <Labels
                                    name="Designer"
                                    text={authorObj && authorObj[0] && authorObj[0].name} />
                            </Grid.Row>
                        </Grid.Column>

                        <Grid.Column width={8}>
                            <Grid.Row>
                                <Labels
                                    name="Overview"
                                    text={
                                        <span ><br />
                                            <Icon name="sitemap" color="grey" />
                                            <span className="ui blue circular label cardLabel">
                                                {this.props.selectedPracticeLibrary.countList ? this.props.selectedPracticeLibrary.countList.activityCount : 0}
                                            </span>
                                            <span> Activities</span>
                                            <br />
                                            <br />
                                            <Icon name="group" color="grey" />
                                            <span className="ui blue circular label cardLabel">
                                                {this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants ? this.props.selectedPracticeLibrary.participants.length : null}
                                            </span>
                                            <span> Participants </span>
                                        </span>} />
                            </Grid.Row>
                        </Grid.Column>

                    </Grid.Row>
                </Grid>
            </div >
        )
    }
}

export default Summary